export default "__VITE_ASSET__BCRyNjaL__"